import { render, staticRenderFns } from "./EditionToolBar.vue?vue&type=template&id=46aa45fd&scoped=true"
import script from "./EditionToolBar.vue?vue&type=script&lang=ts"
export * from "./EditionToolBar.vue?vue&type=script&lang=ts"
import style0 from "./EditionToolBar.vue?vue&type=style&index=0&id=46aa45fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa45fd",
  null
  
)

export default component.exports